import React from 'react';
import moment from 'moment';

import { SingleDatePicker } from 'react-dates';

class SingleDatePickerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  onFocusChange = ({ focused }) => {
    this.setState({ focused });
  }

  render() {
    const { focused } = this.state;

    return (
      <SingleDatePicker
        {...this.props}
        id="date_input"
        focused={focused}
        readOnly
        onFocusChange={this.onFocusChange}
      />
    );
  }
}

export default SingleDatePickerWrapper;



// WEBPACK FOOTER //
// ./src/components/SoonoSocial/SingleDatePickerWrapper.js